import React from 'react';
import cn from 'clsx';
import styles from './index.module.scss';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import { ReviewSubjectDto } from '@interfaces-clean/subject-monitoring/subject-review';
import SubjectsOnReviewGrid from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/subjects-on-review-grid';

type Props = {
    studyRef: string;
    review: EditReviewDto;
    reviewSubjects: ReviewSubjectDto[];
    reviewSubject: boolean;
    sessionId?: string;
};

const SubjectsSection = ({ studyRef, review, reviewSubjects, reviewSubject, sessionId }: Props) => {
    return (
        <div className={cn(styles.gridCell, styles.subjectsSection)}>
            <SubjectsOnReviewGrid
                canEdit
                studyRef={studyRef}
                review={review}
                reviewSubjects={reviewSubjects}
                reviewSubject={reviewSubject}
                sessionId={sessionId}
            />
        </div>
    );
};

export default SubjectsSection;
